// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { Status } from '../../../types';
import ConfigModel from '../../../models/Config';

import StatusBarItem from './StatusBarItem';
import Paper from '@material-ui/core/Paper';

const STATUSBAR_HEIGHT = 50;

const useStyles = makeStyles(theme => ({    root: {
        zIndex: 1,
        position: 'absolute',
        top: 64,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        height: STATUSBAR_HEIGHT,
        backgroundColor: theme.palette.background.paper,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        whiteSpace: 'nowrap',
    }
}));

type Props = $ReadOnly<{
    status: Status
}>;

function StatusBar({ status }: Props) {
    const classes = useStyles();

    const onChange = (id, value) => {
        ConfigModel.setStatus(id, value);
    };

    return (
        <Paper className={classes.root}>
            <StatusBarItem
                label={<label htmlFor="qnh"><FormattedMessage
                    id="statusBar.label.qnh"
                    defaultMessage="QNH"
                /></label>}
                id="qnh"
                inputs={[{
                    id: 'qnh',
                    label: 'hPa'
                }]}
                maxLength={4}
                status={status}
                onChange={onChange}
            />
            <StatusBarItem
                label={<label htmlFor="wind"><FormattedMessage
                    id="statusBar.label.wind"
                    defaultMessage="Wind"
                /></label>}
                id="wind"
                inputs={[
                    {
                        id: 'speed',
                        label: 'knt'
                    },
                    {
                        id: 'angle',
                        label: '°'
                    }
                ]}
                maxLength={3}
                status={status}
                onChange={onChange}
            />
            <StatusBarItem
                label={<label htmlFor="dewPoint"><FormattedMessage
                    id="statusBar.label.dewPoint"
                    defaultMessage="Dew point"
                /></label>}
                id="dewPoint"
                inputs={[{
                    id: 'dewPoint',
                    label: '°C'
                }]}
                maxLength={2}
                status={status}
                onChange={onChange}
            />
            <StatusBarItem
                label={<label htmlFor="temp"><FormattedMessage
                    id="statusBar.label.temp"
                    defaultMessage="Temp"
                /></label>}
                id="temp"
                inputs={[{
                    id: 'temp',
                    label: '°C'
                }]}
                maxLength={2}
                status={status}
                onChange={onChange}
            />
        </Paper>
    );
}

export default StatusBar;